import { useState } from 'react';

import AgConfirmationModal from '@/components/common/ModalWindow/AgConfirmationModal';
import { GetContractDetails } from '@/graphql/contracts/_generated_/getContractDetails.query';
import modalStyles from './party-modal.module.scss';
import { IPartyFormValues } from './PartyHeaders';


interface IContractPartiesModalProps {
  isOpen: boolean;
  onClose: () => void;
  onContinue: (shipToChecked: boolean, invoiceToChecked: boolean) => void;
  contract: GetContractDetails['contract'] | undefined;
  formValues: IPartyFormValues;
  getNormalizedIdsAndChanged: (
    oldId: string | undefined | null,
    newId: string | undefined | null
  ) => {
    normalizedOldId: string | undefined;
    normalizedNewId: string | undefined;
    changed: boolean;
  };
}

const ContractPartiesModal = ({
  isOpen,
  onClose,
  onContinue,
  contract,
  formValues,
  getNormalizedIdsAndChanged
}: IContractPartiesModalProps) => {
  const [shipToChecked, setShipToChecked] = useState(false);
  const [invoiceToChecked, setInvoiceToChecked] = useState(false);

  const shipToChanged = getNormalizedIdsAndChanged(
    contract?.shipToCustomer?.customerID,
    formValues.shipToCustomer?.customerID
  ).changed;

  const invoiceToChanged = getNormalizedIdsAndChanged(
    contract?.invoiceToCustomer?.customerID,
    formValues.invoiceToCustomer?.customerID
  ).changed;

  const showConditionalText = shipToChanged || invoiceToChanged;

  const handleContinue = () => {
    onContinue(shipToChecked, invoiceToChecked);
  };

  return (
    <AgConfirmationModal
      title="Modify Contract Parties"
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleContinue}
      contentStyle={{ minWidth: '500px' }}
    >
      <div className={modalStyles['party-modal-header']}>
        You are about to modify the contract parties.
        {showConditionalText && (
          <><br/><b>Would you like to default the ship/
          invoice parties to the contract lines? Tick the box(es) to apply the update.</b></>
        )}
      </div>

      {showConditionalText && (
        <div className={modalStyles['party-modal-checkboxes']}>
          <label className={modalStyles['party-modal-checkbox-label']}>
            <input
              type="checkbox"
              checked={shipToChecked}
              onChange={(e) => setShipToChecked(e.target.checked)}
              disabled={!shipToChanged}
            />
            <b>Default Ship To</b>
          </label>
          <label className={modalStyles['party-modal-checkbox-label']}>
            <input
              type="checkbox"
              checked={invoiceToChecked}
              onChange={(e) => setInvoiceToChecked(e.target.checked)}
              disabled={!invoiceToChanged}
            />
            <b>Default Invoice To</b>
          </label>
        </div>
      )}
    </AgConfirmationModal>
  );
};

export default ContractPartiesModal;